import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function MapUpdater({ observedDivRef }: {
  observedDivRef: React.RefObject<HTMLDivElement | null>;
}) {
  const map = useMap();

  useEffect(() => {
    if (!map || !observedDivRef.current) return () => {};

    const resizeObserver = new ResizeObserver(() => {
      map.invalidateSize();
    });

    resizeObserver.observe(observedDivRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [map, observedDivRef]);

  return null;
}
